// extracted by mini-css-extract-plugin
export default {"collapse":"collapse-header_collapse__mREy0","collapseDiv":"collapse-header_collapseDiv__hpjr1"};